<template>
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <strong class="mb-2 red text-uppercase">
                {{ $t('parcelas.n_parcela') }}
                {{ parcela.numero }}
            </strong>
            <div class="mt-1">
                <label class="mb-1 text-bold">
                    Zona:
                </label>
                {{ parcela.zona.nombre }}
            </div>
        </div>
        <div class="d-flex flex-column align-items-center ml-3">
            <div class="text-center mr-2">
                <label>{{ $t("gracias.precio") }}</label><br />
                <span class="h2">
                    <span 
                        class="h1 m-0" 
                    >
                        {{ parcela.precio | formatear_precio }}
                    </span>
                </span>
            </div>
            <div v-if="parcela.url_pdf" class="mt-3">
                <a
                    :href="parcela.url_pdf"
                    class="button button-red button-xs"
                    target="_blank"
                >
                    DESCARGAR PDF
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            parcela: {
                type: Object,
                required: true
            }
        }
    }
</script>